import { useEffect, useState } from "react";
import TitleTable from "./SubUserManagment/TitleTable";
import RowUser from "./SubUserManagment/RowUser";
import AddUser from "./SubUserManagment/AddUser";
import SuccessMsg from "./SubUserManagment/SuccessMsg";
import Pagination from "./SubUserManagment/Pagination";
import Loading from "../SubDashboard/Loading/Loading";
import ErrorMsg from "./SubUserManagment/ErrorMsg";
import useUsers from "../SubDashboard/Hooks/UseUsers";
import UserHeader from "./SubUserManagment/UserHeader";
import NotFound from "../../msg/NotFound";

function UserManagment() {
    const [openAddUser, setOpenAddUser] = useState(false);
    const [openSuccess, setOpenSuccess] = useState("");
    const [openError, setOpenError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(16);
    const [searchValue, setSearchValue] = useState("");
    const [successCheck, setSuccessCheck] = useState("");
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [filterOrg, setFilterOrg] = useState("همه");

    const { users, setUsers, filteredUsers, loading, error } =
        useUsers(successCheck, searchValue);

    // 🔒 امنیت دیتا (جلوگیری از crash)
    const safeUsers = Array.isArray(users) ? users : [];
    const safeFilteredUsers = Array.isArray(filteredUsers)
        ? filteredUsers
        : [];

    // فیلتر سازمان
    const orgFilteredUsers =
        filterOrg === "همه"
            ? safeFilteredUsers
            : safeFilteredUsers.filter((u) => u.name === filterOrg);

    // pagination
    const indexOfLast = currentPage * postsPerPage;
    const indexOfFirst = indexOfLast - postsPerPage;

    const currentPosts = orgFilteredUsers.slice(
        indexOfFirst,
        indexOfLast
    );

    // empty state واقعی (بدون crash)
    const isEmptyUsers =
        !loading && !error && safeUsers.length === 0;

    const handleUserAdded = (newUser) => {
        setUsers((prev) => {
            const safePrev = Array.isArray(prev) ? prev : [];
            return [newUser, ...safePrev];
        });

        setCurrentPage(1);
        setSuccessCheck(Date.now());
    };

    const handleSelectUser = (id, checked) => {
        setSelectedUsers((prev) =>
            checked
                ? [...prev, id]
                : prev.filter((uid) => uid !== id)
        );
    };

    const handleSearch = (value) => {
        const cleaned = value.startsWith("0")
            ? value.slice(1)
            : value;

        setSearchValue(cleaned);
        setCurrentPage(1);
    };

    const handleUserDeleted = (value) => {
        console.log(value)
        setSuccessCheck(value);
    };

    return (
        <>
            <div className="m-10">

                <UserHeader
                    selectedUsers={selectedUsers}
                    users={safeUsers}
                    setSelectedUsers={setSelectedUsers}
                    setOpenAddUser={setOpenAddUser}
                    handleSearch={handleSearch}
                    setFilterOrg={setFilterOrg}
                    openError={setOpenError}
                    openSuccess={setOpenSuccess}
                />

                {/* UI STATES */}
                {loading ? (
                    <Loading />
                ) : error ? (
                    <ErrorMsg close={setOpenError} msg={error} />
                ) : isEmptyUsers ? (
                    <div className="rounded-lg text-center bg-yellow-50 border border-yellow-200 px-4 py-3 text-yellow-700">
                        هیچ سازمانی در سیستم ثبت نشده است
                    </div>
                ) : orgFilteredUsers.length === 0 ? (
                    <NotFound text="موردی مطابق جستجو پیدا نشد" />
                ) : (
                    <>
                        <TitleTable />

                        {currentPosts.map((u, i) => (
                            <RowUser
                                key={u.id}
                                item={u}
                                index={i}
                                chooseMsgSuccess={setSuccessCheck}
                                onSelect={handleSelectUser}
                                isSelected={selectedUsers.includes(u.id)}
                                openError={setOpenError}
                                openSuccess={setOpenSuccess}
                                onDeleted={handleUserDeleted}
                            />
                        ))}

                        <Pagination
                            postsPerPage={postsPerPage}
                            totalPosts={orgFilteredUsers.length}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />
                    </>
                )}
            </div>

            {/* MODALS */}
            {openAddUser && (
                <AddUser
                    close={setOpenAddUser}
                    onUserAdded={handleUserAdded}
                    openError={setOpenError}
                    openSuccess={setOpenSuccess}
                />
            )}

            {openSuccess && (
                <SuccessMsg
                    close={setOpenSuccess}
                    msg={openSuccess}
                />
            )}

            {(openError || error) && (
                <ErrorMsg
                    close={setOpenError}
                    msg={openError || error}
                />
            )}
        </>
    );
}

export default UserManagment;



// import { useState } from "react";
// import TitleTable from "./SubUserManagment/TitleTable";
// import RowUser from "./SubUserManagment/RowUser";
// import AddUser from "./SubUserManagment/AddUser";
// import SuccessMsg from "./SubUserManagment/SuccessMsg";
// import Pagination from "./SubUserManagment/Pagination";
// import Loading from "../SubDashboard/Loading/Loading";
// import ErrorMsg from "./SubUserManagment/ErrorMsg";
// import useUsers from "../SubDashboard/Hooks/UseUsers";
// import UserHeader from "./SubUserManagment/UserHeader";
// import NotFound from "../../msg/NotFound";

// function UserManagment() {
//     const [openAddUser, setOpenAddUser] = useState(false);
//     const [openSuccess, setOpenSuccess] = useState("");
//     const [openError, setOpenError] = useState("");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [postsPerPage] = useState(16);
//     const [searchValue, setSearchValue] = useState("");
//     const [successCheck, setSuccessCheck] = useState("");
//     const [selectedUsers, setSelectedUsers] = useState([]);
//     const [filterOrg, setFilterOrg] = useState("همه");

//     const { users, setUsers, filteredUsers, loading, error } =
//         useUsers(successCheck, searchValue);

//     // فیلتر سازمان
//     const orgFilteredUsers =
//         filterOrg === "همه"
//             ? filteredUsers
//             : filteredUsers.filter((u) => u.name === filterOrg);

//     // pagination
//     const indexOfLast = currentPage * postsPerPage;
//     const indexOfFirst = indexOfLast - postsPerPage;
//     const currentPosts = orgFilteredUsers.slice(indexOfFirst, indexOfLast);

//     // بررسی خالی بودن کل دیتا از API
//     const isEmptyUsers = !loading && !error && users.length === 0;

//     const handleUserAdded = (newUser) => {
//         setUsers((prev) => [newUser, ...prev]);
//         setCurrentPage(1);
//         setSuccessCheck(Date.now());
//     };

//     const handleSelectUser = (id, checked) => {
//         setSelectedUsers((prev) =>
//             checked
//                 ? [...prev, id]
//                 : prev.filter((uid) => uid !== id)
//         );
//     };

//     const handleSearch = (value) => {
//         const cleaned = value.startsWith("0")
//             ? value.slice(1)
//             : value;

//         setSearchValue(cleaned);
//         setCurrentPage(1);
//     };

//     return (
//         <>
//             <div className="m-10">
//                 <UserHeader
//                     selectedUsers={selectedUsers}
//                     users={users}
//                     setSelectedUsers={setSelectedUsers}
//                     setOpenAddUser={setOpenAddUser}
//                     handleSearch={handleSearch}
//                     setFilterOrg={setFilterOrg}
//                     openError={setOpenError}
//                     openSuccess={setOpenSuccess}
//                 />

//                 {/* حالات اصلی UI */}
//                 {loading ? (
//                     <Loading />
//                 ) : error ? (
//                     <ErrorMsg close={setOpenError} msg={error} />
//                 ) : isEmptyUsers ? (
//                 <div className="rounded-lg text-center bg-yellow-50 border border-yellow-200 px-4 py-3 text-yellow-700">
//                     هیچ کاربری در سیستم ثبت نشده است
//                 </div>
//                 ) : orgFilteredUsers.length === 0 ? (
//                     <NotFound text="موردی مطابق جستجو پیدا نشد" />
//                 ) : (
//                     <>
//                         <TitleTable />

//                         {currentPosts.map((u, i) => (
//                             <RowUser
//                                 key={u.id}
//                                 item={u}
//                                 index={i}
//                                 chooseMsgSuccess={setSuccessCheck}
//                                 onSelect={handleSelectUser}
//                                 isSelected={selectedUsers.includes(u.id)}
//                                 openError={setOpenError}
//                                 openSuccess={setOpenSuccess}
//                             />
//                         ))}

//                         <Pagination
//                             postsPerPage={postsPerPage}
//                             totalPosts={orgFilteredUsers.length}
//                             currentPage={currentPage}
//                             onPageChange={setCurrentPage}
//                         />
//                     </>
//                 )}
//             </div>

//             {/* مودال‌ها */}
//             {openAddUser && (
//                 <AddUser
//                     close={setOpenAddUser}
//                     onUserAdded={handleUserAdded}
//                     openError={setOpenError}
//                     openSuccess={setOpenSuccess}
//                 />
//             )}

//             {openSuccess && (
//                 <SuccessMsg
//                     close={setOpenSuccess}
//                     msg={openSuccess}
//                 />
//             )}

//             {(openError || error) && (
//                 <ErrorMsg
//                     close={setOpenError}
//                     msg={openError || error}
//                 />
//             )}
//         </>
//     );
// }

// export default UserManagment;



// // import { useState } from "react";
// // import TitleTable from "./SubUserManagment/TitleTable";
// // import RowUser from "./SubUserManagment/RowUser";
// // import AddUser from "./SubUserManagment/AddUser";
// // import SuccessMsg from "./SubUserManagment/SuccessMsg";
// // import Pagination from "./SubUserManagment/Pagination";
// // import Loading from "../SubDashboard/Loading/Loading";
// // import ErrorMsg from "./SubUserManagment/ErrorMsg";
// // import useUsers from "../SubDashboard/Hooks/UseUsers";
// // import UserHeader from "./SubUserManagment/UserHeader";
// // import NotFound from "../../msg/NotFound";

// // function UserManagment() {
// //     const [openAddUser, setOpenAddUser] = useState(false);
// //     const [openSuccess, setOpenSuccess] = useState("");
// //     const [openError, setOpenError] = useState("");
// //     const [currentPage, setCurrentPage] = useState(1);
// //     const [postsPerPage] = useState(16);
// //     const [searchValue, setSearchValue] = useState("");
// //     const [successCheck, setSuccessCheck] = useState("");
// //     const [selectedUsers, setSelectedUsers] = useState([]);
// //     const [filterOrg, setFilterOrg] = useState("همه");

// //     const { users, setUsers, filteredUsers, loading, error, setError } = useUsers(successCheck, searchValue);

// //     const orgFilteredUsers =
// //         filterOrg === "همه"
// //             ? filteredUsers
// //             : filteredUsers.filter((u) => u.name === filterOrg);

// //     const indexOfLast = currentPage * postsPerPage;
// //     const indexOfFirst = indexOfLast - postsPerPage;
// //     const currentPosts = orgFilteredUsers.slice(indexOfFirst, indexOfLast);

// //     const handleUserAdded = (newUser) => {
// //         setUsers((prev) => [newUser, ...prev]);
// //         setCurrentPage(1);
// //         setSuccessCheck(Date.now());
// //     };

// //     const handleSelectUser = (id, checked) => {
// //         setSelectedUsers((prev) =>
// //             checked ? [...prev, id] : prev.filter((uid) => uid !== id)
// //         );
// //     };

// //     const handleSearch = (value) => {
// //         const cleaned = value.startsWith("0") ? value.slice(1) : value;
// //         setSearchValue(cleaned);
// //     };

// //     return (
// //         <>
// //             <div className="m-10">
// //                 <UserHeader
// //                     selectedUsers={selectedUsers}
// //                     users={users}
// //                     setSelectedUsers={setSelectedUsers}
// //                     setOpenAddUser={setOpenAddUser}
// //                     handleSearch={handleSearch}
// //                     setFilterOrg={setFilterOrg}
// //                     openError={setOpenError}
// //                     openSuccess={setOpenSuccess}
// //                 />

// //                 {orgFilteredUsers.length === 0 ? (
// //                     <NotFound text="متاسفانه سازمانی یافت نشد" />
// //                 ) : (
// //                     <>
// //                         <TitleTable />
// //                         {currentPosts.map((u, i) => (
// //                             <RowUser
// //                                 key={u.id}
// //                                 item={u}
// //                                 index={i}
// //                                 chooseMsgSuccess={setSuccessCheck}
// //                                 onSelect={handleSelectUser}
// //                                 isSelected={selectedUsers.includes(u.id)}
// //                                 openError={setOpenError}
// //                                 openSuccess={setOpenSuccess}
// //                             />
// //                         ))}

// //                         <Pagination
// //                             postsPerPage={postsPerPage}
// //                             totalPosts={orgFilteredUsers.length}
// //                             currentPage={currentPage}
// //                             onPageChange={setCurrentPage}
// //                         />
// //                     </>
// //                 )}
// //             </div>

// //             {openAddUser && (
// //                 <AddUser
// //                     close={setOpenAddUser}
// //                     onUserAdded={handleUserAdded}
// //                     openError={setOpenError}
// //                     openSuccess={setOpenSuccess}
// //                 />
// //             )}

// //             {openSuccess && <SuccessMsg close={setOpenSuccess} msg={openSuccess} />}

// //             {(openError || error) && (
// //                 <ErrorMsg close={setOpenError} msg={openError || error} />
// //             )}

// //             {loading && <Loading />}
// //         </>
// //     );
// // }
// // export default UserManagment;